/* Aino homepage rollout; legacy 30/70 mode remains available for rollback. No chat content or customer details enter analytics. */
(() => {
  if (window.DisturbAinoExperiment) return;
  const script=document.querySelector('script[data-aino-experiment]');if(!script)return;
  const cfg=script.dataset, preview=cfg.mode==='preview',full=cfg.rollout==='all';
  const experimentId=full?(preview?'aino_100_preview_v1':'aino_100_v1'):(preview?'aino_30_preview_v1':'aino_30_v1');
  const key=full?(preview?'disturb_aino_100_preview':'disturb_aino_100_v1'):(preview?'disturb_aino_ab_preview':'disturb_aino_ab_v1');
  const lifetime=90*86400000;let state=null,assigned=false,exposed=false;
  const allowed=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;
  const active=()=>cfg.enabled==='true' && !window.Shopify?.designMode;
  const emit=(name,details={})=>{
    if(!active() || !allowed() || !state || typeof window.Shopify?.analytics?.publish!=='function')return false;
    const safe={experiment_id:experimentId,variant:state.variant,test_traffic:preview?1:0,event_id:crypto.randomUUID()};
    for(const k of ['result_count','duration_ms','product_id','category','action','error_code','set_count','topic','engine'])if(details[k]!=null)safe[k]=details[k];
    try{window.Shopify.analytics.publish(name,safe);return true;}catch{return false;}
  };
  const paint=()=>{
    for(const el of document.querySelectorAll('[data-aino-ab]')){
      el.hidden=!active() || !(full || state?.variant==='aino');
      el.dataset.abReady=active() && (full || state?.variant==='aino')?'true':'false';
      const wrapper=el.closest?.('[data-aino-ab-wrapper]');if(wrapper)wrapper.hidden=el.hidden;
    }
    document.dispatchEvent(new CustomEvent('aino:experiment-ready'));
  };
  const sync=()=>{
    if(!active() || !allowed()){
      state=null;try{localStorage.removeItem(key);}catch{}paint();return;
    }
    if(!state){
      try{const old=JSON.parse(localStorage.getItem(key));if(old?.experiment_id===experimentId && (full?old.variant==='aino':['aino','control'].includes(old.variant)) && old.expires_at>Date.now())state=old;}catch{}
      if(!full && !state && cfg.homepage!=='true'){paint();return;}
      if(!state){
        const sample=crypto.getRandomValues(new Uint32Array(1))[0]/4294967296;
        state={experiment_id:experimentId,variant:full || preview?'aino':sample<0.3?'aino':'control',expires_at:Date.now()+lifetime};
        try{localStorage.setItem(key,JSON.stringify(state));}catch{state=null;}
      }
    }
    paint();if(!state)return;
    emit('aino_context');
    if(!assigned && cfg.homepage==='true'){assigned=emit('aino_assignment');}
    if(state.variant==='aino'){
      const el=document.querySelector('[data-aino-ab]');if(el && !exposed){
        const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting) && !exposed){exposed=emit('aino_exposure');if(exposed)observer.disconnect();}},{threshold:0.25});observer.observe(el);
      }
    }
  };
  window.DisturbAinoExperiment={emit,get state(){return state;},get preview(){return preview;},sync};
  document.addEventListener('visitorConsentCollected',sync);
  document.addEventListener('shopifyCustomerPrivacyApiLoaded',sync);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync,{once:true});else sync();
  // Shopify can install its privacy API asynchronously, even before its loaded event listener exists.
  if(!window.Shopify?.customerPrivacy)window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],sync);
  let attempts=0;const wait=setInterval(()=>{if(++attempts>40){clearInterval(wait);return;}if(window.Shopify?.customerPrivacy){sync();clearInterval(wait);}},250);
})();
